import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { ZIndex } from '../constants';
import { Avatar } from '@mui/material';
import { Colors, MediaBreakPointUp, Sizes, drawerWidth } from '@lean-body/components/styles';
import { Menu } from '@lean-body/components/organisms';
import { SettingMenu, SettingItemKeys } from '@lean-body/components/organisms/setting_menu';
import { useQuery, useSmMediaQuery, useXlMediaQuery } from '@lean-body/src/util';
import { routes } from '@lean-body/src/route';
import { Logo } from '../atoms';
import { HeaderStreakBadge } from '../molecules/header_streak_badge';
import { HeaderRightItems } from '../molecules/header_right_items';
import { TvConnectionBanner } from './tv_connection_banner';
import { useMissionNotification } from '../hooks/use_mission_notification';
export const STICKY_HEADER_ROUTES = [routes.TOP.compile()];
export const Header = ({ isDormant, isMegalosUser, payment, footer, unreadAnnouncementCount, accountService, me, profile, config, currentStreak, isTvBannerVisible, onCloseTvBanner, apiClient, }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const query = useQuery();
    const isSM = useSmMediaQuery();
    const isXL = useXlMediaQuery();
    const [openSetting, setOpenSetting] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState(SettingItemKeys[query.get('key')]);
    const isTopRoute = routes.TOP.compile() === location.pathname;
    useMissionNotification(apiClient, isDormant);
    const onClickSwitchSettingMenu = () => {
        setOpenSetting(!openSetting);
        window.scrollTo(0, 0);
    };
    const onClickSettingMenu = (key) => {
        setCurrentItem(key);
        navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys[key]}`);
        setOpenSetting(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.positionFixed, isTopRoute && styles.positionSticky, isTopRoute && styles.positionFixedHomeXl, !isTopRoute && !isSM && styles.hideHeader) },
            isTopRoute && !isXL && (React.createElement(TvConnectionBanner, { config: config, isVisible: isTvBannerVisible, onClose: onCloseTvBanner })),
            React.createElement("div", { className: css(styles.container, isTopRoute && styles.containerHomeXl), id: "fixedHeader" },
                isSM && (React.createElement(Avatar, { "data-cy": 'setting-menu', src: profile.pictureSrc, onClick: onClickSwitchSettingMenu, className: css(styles.avatar, profile.profilePictureSrc && styles.avatarBorder) })),
                isTopRoute
                    ? currentStreak && (React.createElement(Link, { to: routes.ACTIVITY.compile(), className: css(styles.logoLink) },
                        React.createElement(HeaderStreakBadge, { classObject: styles.streakBadge, currentStreak: currentStreak })))
                    : isSM && (React.createElement(Link, { to: routes.TOP.compile(), className: css(styles.logoLink) },
                        React.createElement(Logo, { classObject: styles.logo }))),
                isSM && !isDormant && React.createElement(HeaderRightItems, { unreadAnnouncementCount: unreadAnnouncementCount }))),
        !isSM && (React.createElement(Menu, { className: css(styles.menu), isMegalosUser: isMegalosUser, unreadAnnouncementCount: unreadAnnouncementCount, me: me, footer: footer })),
        isSM && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css(!openSetting && styles.displayNone, styles.settingMenuBackGround), onClick: onClickSwitchSettingMenu }),
            React.createElement(SettingMenu, { classObject: [styles.settingMenu, openSetting ? styles.menuOpen : styles.menuClose], currentItem: currentItem, onClick: onClickSettingMenu, onClickClose: onClickSwitchSettingMenu, isMegalosUser: payment === null || payment === void 0 ? void 0 : payment.isMegalosUser, me: me, isStripeUser: payment.isStripePayment(), onClickSignOut: () => {
                    accountService.signOut();
                }, profile: profile })))));
};
const styles = StyleSheet.create({
    container: {
        height: Sizes.MobileHeaderHeight,
        width: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    containerHomeXl: {
        [MediaBreakPointUp.XL]: {
            height: 'auto',
            paddingBottom: 16,
        },
    },
    hideHeader: {
        display: 'none',
    },
    positionFixed: {
        position: 'fixed',
        zIndex: ZIndex.Header,
        width: '100%',
        background: Colors.White,
        [MediaBreakPointUp.MD]: {
            left: drawerWidth.md,
            right: 0,
            width: 'unset',
        },
        [MediaBreakPointUp.XL]: {
            left: drawerWidth.xl,
        },
    },
    positionFixedHomeXl: {
        [MediaBreakPointUp.XL]: {
            padding: '24px 30px 0',
        },
    },
    positionSticky: {
        position: 'sticky',
        top: 0,
        [MediaBreakPointUp.MD]: {
            marginLeft: drawerWidth.md,
        },
        [MediaBreakPointUp.XL]: {
            marginLeft: drawerWidth.xl,
        },
    },
    menu: {
        display: 'block',
        position: 'fixed',
        top: 0,
        left: 0,
        width: drawerWidth.xs,
        height: '100%',
        zIndex: ZIndex.MainMenu,
        transform: 'translate3d(-100%, 0, 0)',
        transition: 'all .3s ease',
        boxShadow: 'none',
        [MediaBreakPointUp.MD]: {
            width: drawerWidth.md,
            transform: 'translate3d(0, 0, 0)',
            boxShadow: 'none',
        },
        [MediaBreakPointUp.XL]: {
            width: drawerWidth.xl,
        },
    },
    logo: {
        width: 141,
        height: 'auto',
    },
    streakBadge: {},
    logoLink: {
        display: 'block',
    },
    settingMenu: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        overflow: 'scroll',
        width: 'calc(100% - 60px)',
        border: `1px ${Colors.BorderLightGray} solid`,
        zIndex: ZIndex.SettingMenuDrawer,
    },
    menuOpen: {
        transform: 'translate(0, 0)',
    },
    menuClose: {
        transform: 'translate(-100%, 0)',
    },
    settingMenuBackGround: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        backgroundColor: Colors.Black,
        opacity: 0.4,
        zIndex: ZIndex.SettingMenuDrawer,
    },
    displayNone: {
        display: 'none',
    },
    avatar: {
        position: 'absolute',
        left: 18,
        width: 28,
        height: 28,
        cursor: 'pointer',
    },
    avatarBorder: {
        border: `0.5px solid ${Colors.Gray}`,
    },
});
